import { Dropdown, Form } from "react-bootstrap";
import { useState } from "react";
import { withNamespaces } from "react-i18next";

const ColumnCustomizer = ({ 
    t, 
    allColumns, 
    visibleColumns, 
    onChange,
    title = 'Customize Table'
}) => {
    const [show, setShow] = useState(false);
    
    return (
        <Dropdown show={show} onToggle={() => setShow(!show)}>
            <Dropdown.Toggle variant="outline-secondary">
                {t(title)}
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ width: '250px' }}>
                {allColumns.filter((col) => !col.locked).map((col) => (
                    <div
                        key={col.dataField}
                        style={{
                            padding: '5px 15px'
                        }}
                    >
                        <Form.Check
                            type="checkbox"
                            id={`col-${col.dataField}`}
                            label={col.text}
                            checked={visibleColumns.includes(col.dataField)}
                            onChange={() => onChange(col)}
                        />
                    </div>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default withNamespaces()(
    ColumnCustomizer
);
